<template>
  <div>
    <div>
      <img
        ref="image"
        :src="uploadImageSrc"
      />
    </div>
  </div>
</template>

<script>
  import Cropper from 'cropperjs'
  import 'cropperjs/dist/cropper.min.css'

  export default {
    name: 'Cropper',
    props: {
      aspectRatio: {
        type: Number,
        default: 1,
      },
      uploadImageSrc: {
        type: String,
        required: true,
      },
      getDataUrl: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      cropper: null,
    }),
    watch: {
      getDataUrl(val) {
        if (val) {
          this.$emit('dataUrl', this.cropper.getCroppedCanvas().toDataURL())
        }
      },
    },
    mounted() {
      const { image } = this.$refs
      this.cropper = new Cropper(image, {
        aspectRatio: this.aspectRatio,
        viewMode: 1,
        dragMode: 'crop',
        minCropBoxWidth: 240,
        minCropBoxHeight: 240,
      })
    },

  }
</script>

<style scoped>
  img {
    display: block;
    max-width: 100%;
  }
</style>
